import PropTypes from 'prop-types';
import { DropTarget } from 'react-dnd';
import RelationshipsDisplay from './RelationshipsDisplay';
import React from 'react';

const Types = {
  CONCEPT: 'concept',
  ANNOTATION: 'annotation',
  XLLABEL: 'xllabel'
};

const conceptTarget = {
  canDrop(props, monitor) {
    if (props.isReadOnly) return false;
    const item = monitor.getItem();
    if (item.type === "Concept") {
      if (props.values && props.values.includes(item.conceptId)) return false;
      return item.conceptId !== props.source;
    }
    else if (item.type === "Annotation") {
      return item.annotationLang === props.defaultLang;
    }
    else if (item.type === "Label") {
      return item.labelLang === props.defaultLang;
    }
    else return true;
  },
  drop(props, monitor) {
    // Handled by child target?
    if (monitor.getDropResult() && monitor.getDropResult().handled) return;
    const item = monitor.getItem();
    if (item.type === "Concept") {
      props.onMove(item.conceptId);
    }
    else if (item.type === "Annotation") {
      props.onConvertToConcept(item.annotationLabel, item.annotationLang);
    }
    else {
      props.onConvertLabelToConcept(item.label, item.labelId, item.labelLang);
    }
  }
};

function collectTarget(connect, monitor) {
  return {
    canDrop: monitor.canDrop(),
    connectDropTarget: connect.dropTarget(),
    isOver: monitor.isOver({shallow: true})
  };
}

class DropRelationshipsDisplay extends React.Component {

  render() {

    const { isOver, canDrop, connectDropTarget, isReadOnly } = this.props;

    return connectDropTarget(
      <div style={{ height: '100%' }}>
        <RelationshipsDisplay {...this.props} highlight={isOver && canDrop && !isReadOnly} />
      </div>
    );
  }
}

DropRelationshipsDisplay.defaultProps = {
  isRequired: false
};

DropRelationshipsDisplay.propTypes = {
  isReadOnly: PropTypes.bool,
  useWorkflow: PropTypes.bool,
  source: PropTypes.string.isRequired,
  onMove: PropTypes.func.isRequired,
  onConvertLabelToConcept: PropTypes.func.isRequired,
  onConvertToConcept: PropTypes.func.isRequired,
};

export default DropTarget([Types.CONCEPT, Types.ANNOTATION, Types.XLLABEL], conceptTarget, collectTarget)(DropRelationshipsDisplay);